<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ART &HUMANITIES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Library Science</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Post Graduate</th>
                            <th class="time">Under Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">M.Lib</td>
                            <td class="time">B.Lib</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">B.Lib</b>
                    – The Bachelor of Library and Information Science (B.Lib) program at ARNI University is a one-year
                    professional degree designed for students who aspire to build a career in library management,
                    information science, and knowledge organization. The program equips students with theoretical
                    knowledge and practical skills in modern library systems, digital information management, and
                    research methodologies.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I</b> : Fundamentals of Library Science
                </p>
                <ul>
                    <li> Foundations of Library & Information Science</li>
                    <li> Management of Libraries & Information Centers/ Institutions</li>
                    <li> Library Classification (Theory)</li>
                    <li> Library Cataloguing (Theory)</li>
                    <li> Library Classification Practice</li>
                    <li> Library Cataloguing Practice</li>
                    <li> Knowledge Organization and Information Retrieval (Theory)</li>
                    <li> Knowledge Organization Practice</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II</b> : Advanced Library & Information
                    Science
                </p>
                <ul>
                    <li> Information Processing and Retrieval</li>
                    <li> IT Applications in Libraries (Theory)</li>
                    <li> Information Sources</li>
                    <li> Information Users, Systems, and Services</li>
                    <li> Library & Information Technology: Theory</li>
                    <li> Library and Information Technology: Practice</li>

                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">M.Lib </b>
                    – The Master of Library and Information Science (M.Lib) program at ARNI University is designed to
                    provide advanced knowledge and professional expertise in the field of library science, information
                    management, and digital archiving. This program equips students with in-depth skills in library
                    automation, research methodologies, information retrieval systems, and data organization, preparing
                    them for leadership roles in academic, corporate, and public libraries.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Advanced Library & Information
                    Science
                </p>
                <ul>
                    <li> Foundations of Library & Information Science</li>
                    <li> Research Methodology & Data Analysis</li>
                    <li> Library Management & Administration</li>
                    <li> Information Retrieval & Knowledge Organization</li>
                    <li> Library Automation & Digital Libraries</li>
                    <li> Open Access & Digital Repositories</li>
                    <li> Internship & Practical Training</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Emerging Trends & Specialization
                </p>
                <ul>
                    <li> Artificial Intelligence & Library Science</li>
                    <li> Information Communication & Networking</li>
                    <li> Preservation & Conservation of Information Resources</li>
                    <li> Intellectual Property Rights & Plagiarism in Research</li>
                    <li> Data Science & Analytics in Library Management</li>
                    <li> Dissertation & Research Project</li>
                </ul>
            </div>

        </div>

    </div>
</section>
